export const createProductApi = (api) => ({
  createProduct: (categoryId, subCategoryId, data, fpoId) =>
    api.post(`/category/${categoryId}/subCategory/${subCategoryId}/product${fpoId ? `?fpold=${fpoId}` : ""}`, data),
  getProductById: (categoryId, subCategoryId, id) =>
    api.get(`/category/${categoryId}/subCategory/${subCategoryId}/product/${id}`),
  getProducts: (categoryId, subCategoryId) =>
    api.get(`/category/${categoryId}/subCategory/${subCategoryId}/products`),
  updateProduct: (categoryId, subCategoryId, id, data, fpoId) =>
    api.patch(`/category/${categoryId}/subCategory/${subCategoryId}/product/${id}${fpoId ? `?fpold=${fpoId}` : ""}`, data),
  deleteProduct: (categoryId, subCategoryId, id, fpoId) =>
    api.delete(`/category/${categoryId}/subCategory/${subCategoryId}/product/${id}${fpoId ? `?fpold=${fpoId}` : ""}`),

  getProductByHsn: (hsn) => api.get(`/product?hsn=${hsn}`),
  getUnits: () => api.get("/units"),
  getUnitDetails: () => api.get("/units/details"),

  getProductCategories: () => api.get("/category"),
  getProductCategoryById: (id) => api.get(`/category/${id}`),
  createProductCategory: (data) => api.post("/category", data),
  updateProductCategory: (id, data) => api.patch(`/category/${id}`, data),
  deleteProductCategory: (id) => api.delete(`/category/${id}`),

  getSubCategories: (categoryId) => api.get(`/category/${categoryId}/subCategory`),
  getSubCategoryById: (categoryId, id) => api.get(`/category/${categoryId}/subCategory/${id}`),
  createProductSubCategory: (categoryId, data) => api.post(`/category/${categoryId}/subCategory`, data),
  updateSubCategory: (categoryId, id, data) => api.patch(`/category/${categoryId}/subCategory/${id}`, data),
  deleteProductSubCategory: (categoryId, id) => api.delete(`/category/${categoryId}/subCategory/${id}`),

  getTransactionsByProductId: (fpoId, productId) => api.get(`/fpo/${fpoId}/product/${productId}/transaction`),
  addProductTransaction: (fpoId, productId, data) => api.post(`/fpo/${fpoId}/product/${productId}/transaction`, data),
  deleteTransaction: (fpoId, id) => api.delete(`/fpo/${fpoId}/transaction/${id}`),
  updateTransaction: (fpoId, id, data) => api.patch(`/fpo/${fpoId}/transaction/${id}`, data),
  getTransactionsIdByProductId: (fpoId, productId, id) => api.get(`/fpo/${fpoId}/product/${productId}/transaction/${id}`),
  getTransactions: (fpoId) => api.get(`/fpo/${fpoId}/transaction`),
  getTransactionById: (fpoId, productId, id) => api.get(`/fpo/${fpoId}/product/${productId}/transaction/${id}`),

  getFPOProductQuantities: (fpoId, params = {}) => api.get(`/fpo/${fpoId}/product/quantity`, { params }),
  // Own products & quantity list as a file; format "pdf" | "excel", optional limit (plan's product cap)
  downloadFPOProductQuantities: (fpoId, format = "pdf", params = {}) =>
    api.get(`/fpo/${fpoId}/product/quantity/download`, { params: { format, ...params }, responseType: "blob" }),
});
